import { useMedia } from "react-use";
import { MOBILE_MAX_WIDTH } from "../../../constant";
import CloseSvg from "../../common/ui/CloseSvg";
import styles from "./filterCondTagsArea.module.scss";

type Props = {
  text: string;
  close: () => void;
};

const FilterCondTag = ({ text, close }: Props) => {
  const isMobile = useMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`, false);

  return (
    <div className={styles["filter-cond-tag"]} onClick={close}>
      <span className="font-normal whitespace-nowrap">{text}</span>
      <button type="button">
        <CloseSvg size={isMobile ? "12" : "14"} />
      </button>
    </div>
  );
};

export default FilterCondTag;
